import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from 'axios';
import css from './index.module.css';

import SEO from "@components/seo";
import MainContent from "@components/content";
import * as Types from '../../types';
import AddPopupProduct from "@components/addProductPopup";

export default function Product() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState<Types.Product[]>([]);
  const [addProductPopup, setAddProductPopup] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const startX = useRef(0);
  
  const handleTouchStart = (e: React.TouchEvent) => {
    startX.current = e.touches[0].clientX;
  };
  
  const handleTouchEnd = (e: React.TouchEvent) => {
    const endX = e.changedTouches[0].clientX;
    const deltaX = endX - startX.current;
  
    if (Math.abs(deltaX) > 50) {
      if (deltaX > 0) {
        // свайп вправо
        setActiveIndex((prev) => (prev === 0 ? product[0].images.length - 1 : prev - 1));
      } else {
        // свайп влево
        setActiveIndex((prev) => (prev + 1) % product[0].images.length);
      }
    }
  };
  
  useEffect(() => {
    axios.get(`${import.meta.env.VITE_API_URL}/product/${id}`, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      setProduct(response.data);
    }).catch(error => {
      console.log(error)
    });
  }, [id]);

  const back = () => {
    navigate(-1);
  }

  return (
    <MainContent header={null}>      
      <AddPopupProduct product={product[0]} showPopup={addProductPopup} setShowPopup={setAddProductPopup} />
      {product.map((info: Types.Product) => (
      <>
        <SEO 
          title={info.name}
          description={info.desc}
          ogImage={info.images[0]}
          ogUrl={`https://рыбныимир.рф/`}
        />

        <div className={css.mainInfo}>
          <a onClick={back} className={css.exit}><i className="fi fi-rr-angle-small-left"></i></a>
          {info.images.length > 0 && (
            <div
              className={css.imageSwipeBlock}
              style={{ backgroundImage: `url(${info.images[activeIndex]})` }}
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
            >
              <div className={css.dots}>
                {info.images.map((_, index: number) => (
                  <div key={index} className={`${css.dot} ${index === activeIndex ? css.act : ''}`} onClick={() => setActiveIndex(index)} />
                ))}
              </div>
            </div>
          )}

          <div className={css.textBlock}>
            <h1>{info.name}</h1>
            <b>{info.price} ₽ / {info.unit}</b>
            <p dangerouslySetInnerHTML={{__html: info.desc ? info.desc : '' }}></p>
          </div>

          <div className={css.addToCart} onClick={() => setAddProductPopup(true)}>
            <a>Добавить в корзину</a>
          </div>
          <div className={css.addToCart} onClick={back} style={{ margin: 0, background: '#fff', color: '#000', border: '1px solid #000' }}>
            <a>Вернуться назад</a>
          </div>
        </div>
      </>
      ))}
    </MainContent>
  )
}
